export const colors = {
  bg: "#F7F7F7",

  primary: "#FC0108",

  textColor: "#000",
};
